/**
 * Common reusable types for the freight module
 */

/**
 * Book type represents whether a rate or invoice applies to costs or revenue
 */
export const INVOICE_STATUS = {
  NEEDS_APPROVAL: 'needs_approval',
  ERROR: 'error',
  POSTED: 'posted',
  BLOCKED: 'blocked',
  SENT: 'sent',
  CR_APPROVAL: 'cr_approval',
} as const

export const INVOICE_TYPE = {
  ORIGINAL: 'original',
  REBILL: 'rebill',
  CREDIT: 'credit',
} as const

export const DETAIL_TYPE = {
  BASE_FREIGHT: 'Base Freight',
  ACCESSORIAL: 'Accessorial',
  SURCHARGE: 'Surcharge',
  POINT_TO_POINT: 'Point to Point',
  UNDEFINED: 'Undefined',
} as const

export const TransactionQueryKeys = {
  estimated: 'estimatedTransactions',
  open: 'openTransactions',
  posted: 'postedTransactions',
  byOrder: 'transactionByOrder',
  invoice: 'invoice',
} as const

export type BookType = 'Cost' | 'Revenue'

/**
 * Product group types
 */
export type ProductGroup = 'Gasoline' | 'Diesel' | 'Ethanol' | 'BioDiesel'

/**
 * Invoice status types
 */
export type InvoiceStatus =
  | 'needs_attention'
  | 'hold'
  | 'open'
  | 'ready'
  | 'sent'
  | 'cr_approval'
  | 'blocked'
  | 'failure'
  | 'needs_approval'
  | 'error'
  | 'posted'
  | 'estimated'
  | 'cost'
  | 'manual'

/**
 * Invoice type
 */
export type InvoiceType = 'original' | 'rebill' | 'credit'

/**
 * Detail type for invoice line items
 */
export type DetailType = 'Base Freight' | 'Accessorial' | 'Surcharge' | 'Point to Point' | 'Undefined'

/**
 * Common billing units
 */
export type BillingUnit = 'Per Gallon' | 'Per Truck'
